// ----------------------------------------------------------------------

const ROOTS = {
  AUTH: '/auth',
  DASHBOARD: '/dashboard',
};

// ----------------------------------------------------------------------

export const paths = {
  faqs: '/faqs',
  minimalStore: 'https://mui.com/store/items/minimal-dashboard/',
  // AUTH
  auth: {
    amplify: {
      signIn: `${ROOTS.AUTH}/amplify/sign-in`,
      verify: `${ROOTS.AUTH}/amplify/verify`,
      signUp: `${ROOTS.AUTH}/amplify/sign-up`,
      updatePassword: `${ROOTS.AUTH}/amplify/update-password`,
      resetPassword: `${ROOTS.AUTH}/amplify/reset-password`,
      mfaVerify: `${ROOTS.AUTH}/amplify/mfa-verify`,
    },
    jwt: {
      signIn: `${ROOTS.AUTH}/jwt/sign-in`,
      signUp: `${ROOTS.AUTH}/jwt/sign-up`,
    },
    firebase: {
      signIn: `${ROOTS.AUTH}/firebase/sign-in`,
      verify: `${ROOTS.AUTH}/firebase/verify`,
      signUp: `${ROOTS.AUTH}/firebase/sign-up`,
      resetPassword: `${ROOTS.AUTH}/firebase/reset-password`,
    },
    auth0: {
      signIn: `${ROOTS.AUTH}/auth0/sign-in`,
    },
    supabase: {
      signIn: `${ROOTS.AUTH}/supabase/sign-in`,
      verify: `${ROOTS.AUTH}/supabase/verify`,
      signUp: `${ROOTS.AUTH}/supabase/sign-up`,
      updatePassword: `${ROOTS.AUTH}/supabase/update-password`,
      resetPassword: `${ROOTS.AUTH}/supabase/reset-password`,
    },
  },
  // DASHBOARD
  dashboard: {
    root: ROOTS.DASHBOARD,
    reports: {
      root: `${ROOTS.DASHBOARD}/reports`,
      report: (id) => `${ROOTS.DASHBOARD}/reports/report/${id}`,
    },
    groups: {
      root: `${ROOTS.DASHBOARD}/groups`,
      group: (id) => `${ROOTS.DASHBOARD}/groups/${id}`,
    },
    management: {
      root: `${ROOTS.DASHBOARD}/management`,
      user: (id) => `${ROOTS.DASHBOARD}/management/user/${id}`,
    },
    logs: `${ROOTS.DASHBOARD}/logs`,
    test: {
      root: `${ROOTS.DASHBOARD}/configuration`,
      company: `${ROOTS.DASHBOARD}/configuration/company`,
      individual: `${ROOTS.DASHBOARD}/configuration/individual`,
      screening: `${ROOTS.DASHBOARD}/configuration/screening`,
    },
  },
};
